import React from 'react';

import NotificationsProvider from './NotificationsProviderContext';
import Notifications from './Notifications';

const NotificationsWrapper = () => (
  <NotificationsProvider>
    <Notifications />
  </NotificationsProvider>
);

export default NotificationsWrapper;
